<div class="star-rating">
    <mat-icon 
      *ngFor="let star of stars; let i = index" 
    
      style="color:red"
      [ngClass]="{ 'filled': i < rating }">
      {{ i < rating ? 'star' : 'star_border' }}
    </mat-icon>
  </div>